import { Component, Input } from '@angular/core';

@Component({
    selector: 'tvcore-key-value',
    templateUrl: './key-value.component.html',
    styleUrls: ['./key-value.component.scss'],
    standalone: false
})
export class KeyValueComponent {
	@Input()
	key: string;
	@Input()
	info: string;
}
